import script from "./BBW.vue?vue&type=script&lang=js"
export * from "./BBW.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__